import cn from 'classnames';

import { defineTheme, type ThemeKeys } from 'js/utils/theme-helpers';

import Icon, { type IconName } from 'components/icon/Icon';

import { IconWarning_Theme, IIconWarning } from 'source/NFR.types';

const sizes = defineTheme({
  wide: 'icon-warning--size-wide',
  small: 'icon-warning--size-small'
});
const themes = defineTheme({
  red: 'icon-warning--theme-red',
  blue: 'icon-warning--theme-blue',
  gray: 'icon-warning--theme-gray'
});
const themeMap: Record<number, string> = {
  [IconWarning_Theme.None]: '',
  [IconWarning_Theme.Red]: themes('red') ?? '',
  [IconWarning_Theme.Blue]: themes('blue') ?? '',
  [IconWarning_Theme.Gray]: themes('gray') ?? ''
};
type Size = ThemeKeys<typeof sizes>;

interface IconWarningProps extends IIconWarning {
  className?: string;
  size?: Size;
}

const IconWarning: React.FC<IconWarningProps> = ({ className, theme, size }) => {
  const iconName = (): IconName => {
    switch (theme) {
      case IconWarning_Theme.Blue:
        return 'i';
      case IconWarning_Theme.Red:
        return 'warning-triangle';
      default:
        return 'warning-circle';
    }
  };

  return (
    <Icon className={cn('icon-warning', sizes(size), theme ? themeMap[theme] : '', className)} name={iconName()} />
  );
};

IconWarning.displayName = 'IconWarning';

export default IconWarning;
